import objectPrefix from '../../lib/objectPrefix';

const prefix = objectPrefix();

module.exports = {
    agentLeft: {
        type: 'movieclip',
        position: {
            x: '18%',
            y: '-3%',
        },
        scale: {
            x: '70%',
        },
        texture: `sprite:/img/partials/bucket-guards/agents-${prefix}.json,agents/agent-left`,
    },
};



// WEBPACK FOOTER //
// ./js/objects/partials/agentLeft.js